module.exports = __webpack_public_path__ + "static/media/img-apply-btn.db706705.png";